"use strict";

var UnicodeTrie = require('unicode-trie');



var base64 = require('base64-js');

var _require = require('./classes'),
    BK = _require.BK,
    CR = _require.CR,
    LF = _require.LF,
    NL = _require.NL,
    SG = _require.SG,
    WJ = _require.WJ,
    SP = _require.SP,
    ZWJ = _require.ZWJ,
    BA = _require.BA,
    HY = _require.HY,
    NS = _require.NS,
    AI = _require.AI,
    AL = _require.AL,
    CJ = _require.CJ,
    HL = _require.HL,
    RI = _require.RI,
    SA = _require.SA,
    XX = _require.XX;

var _require2 = require('./pairs'),
    DI_BRK = _require2.DI_BRK,
    IN_BRK = _require2.IN_BRK,
    CI_BRK = _require2.CI_BRK,
    CP_BRK = _require2.CP_BRK,
    PR_BRK = _require2.PR_BRK,
    pairTable = _require2.pairTable;

var data = base64.toByteArray("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");
var classTrie = new UnicodeTrie(data);

var mapClass = function mapClass(c) {
  switch (c) {
    case AI:
      return AL;

    case SA:
    case SG:
    case XX:
      return AL;

    case CJ:
      return NS;

    default:
      return c;
  }
};

var mapFirst = function mapFirst(c) {
  switch (c) {
    case LF:
    case NL:
      return BK;

    case SP:
      return WJ;

    default:
      return c;
  }
};

var Break = function Break(position, required) {
  if (required === void 0) {
    required = false;
  }

  this.position = position;
  this.required = required;
};

var LineBreaker = /*#__PURE__*/function () {
  function LineBreaker(string) {
    this.string = string;
    this.pos = 0;
    this.lastPos = 0;
    this.curClass = null;
    this.nextClass = null;
    this.LB8a = false;
    this.LB21a = false;
    this.LB30a = 0;
  }

  var _proto = LineBreaker.prototype;

  _proto.nextCodePoint = function nextCodePoint() {
    var code = this.string.charCodeAt(this.pos++);
    var next = this.string.charCodeAt(this.pos); // If a surrogate pair

    if (0xd800 <= code && code <= 0xdbff && 0xdc00 <= next && next <= 0xdfff) {
      this.pos++;
      return (code - 0xd800) * 0x400 + (next - 0xdc00) + 0x10000;
    }

    return code;
  };

  _proto.nextCharClass = function nextCharClass() {
    return mapClass(classTrie.get(this.nextCodePoint()));
  };

  _proto.getSimpleBreak = function getSimpleBreak() {
    // handle classes not handled by the pair table
    switch (this.nextClass) {
      case SP:
        return false;

      case BK:
      case LF:
      case NL:
        this.curClass = BK;
        return false;

      case CR:
        this.curClass = CR;
        return false;
    }

    return null;
  };

  _proto.getPairTableBreak = function getPairTableBreak(lastClass) {
    // if not handled already, use the pair table
    var shouldBreak = false;

    switch (pairTable[this.curClass][this.nextClass]) {
      case DI_BRK:
        // Direct break
        shouldBreak = true;
        break;

      case IN_BRK:
        // possible indirect break
        shouldBreak = lastClass === SP;
        break;

      case CI_BRK:
        shouldBreak = lastClass === SP;

        if (!shouldBreak) {
          shouldBreak = false;
          return shouldBreak;
        }

        break;

      case CP_BRK:
        // prohibited for combining marks
        if (lastClass !== SP) {
          return shouldBreak;
        }

        break;

      case PR_BRK:
        break;
    }

    if (this.LB8a) {
      shouldBreak = false;
    } // Rule LB21a


    if (this.LB21a && (this.curClass === HY || this.curClass === BA)) {
      shouldBreak = false;
      this.LB21a = false;
    } else {
      this.LB21a = this.curClass === HL;
    } // Rule LB30a


    if (this.curClass === RI) {
      this.LB30a++;

      if (this.LB30a == 2 && this.nextClass === RI) {
        shouldBreak = true;
        this.LB30a = 0;
      }
    } else {
      this.LB30a = 0;
    }

    this.curClass = this.nextClass;
    return shouldBreak;
  };

  _proto.nextBreak = function nextBreak() {
    // get the first char if we're at the beginning of the string
    if (this.curClass == null) {
      var firstClass = this.nextCharClass();
      this.curClass = mapFirst(firstClass);
      this.nextClass = firstClass;
      this.LB8a = firstClass === ZWJ;
      this.LB30a = 0;
    }

    while (this.pos < this.string.length) {
      this.lastPos = this.pos;
      var lastClass = this.nextClass;
      this.nextClass = this.nextCharClass(); // explicit newline

      if (this.curClass === BK || this.curClass === CR && this.nextClass !== LF) {
        this.curClass = mapFirst(mapClass(this.nextClass));
        return new Break(this.lastPos, true);
      }

      var shouldBreak = this.getSimpleBreak();

      if (shouldBreak === null) {
        shouldBreak = this.getPairTableBreak(lastClass);
      } // Rule LB8a


      this.LB8a = this.nextClass === ZWJ;

      if (shouldBreak) {
        return new Break(this.lastPos);
      }
    }

    if (this.pos >= this.string.length) {
      if (this.lastPos < this.string.length) {
        this.lastPos = this.string.length;
        return new Break(this.string.length);
      } else {
        return null;
      }
    }
  };

  return LineBreaker;
}();

module.exports = LineBreaker;